import { render, staticRenderFns } from "./PageColumnWithComponentEditor.vue?vue&type=template&id=a7cf30ca&lang=pug&"
import script from "./PageColumnWithComponentEditor.vue?vue&type=script&lang=ts&"
export * from "./PageColumnWithComponentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PageColumnWithComponentEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports